import { useCallback } from "react";

import { SearchInput } from "@similarweb/ui-components";

import categoryService from "app/common/services/categoryService";
import { swSettings } from "app/common/services/swSettings";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { i18nFilter } from "app/filters/i18nFilter";
import { SearchContainer } from "app/pages/workspace/StyledComponent";
import { DefaultFetchService } from "app/services/fetchService";

export const DemographicsTableTop = ({
    clearAllSelectedRows,
    setDomainFilter,
    queryParams,
    sortedColumn,
    domainFilter,
}) => {
    const handleSearch = useCallback(
        (searchTerm: string) => {
            // In case the user has selected rows on the table,
            // we should clear the selection before filtering the data
            if (clearAllSelectedRows) {
                clearAllSelectedRows();
            }
            setDomainFilter(searchTerm);
        },
        [clearAllSelectedRows, setDomainFilter],
    );

    const EXCEL_ENDPOINT = "widgetApi/DemographicSegmentsIndustry/Excel";
    const fetcherService = DefaultFetchService.getInstance();
    const { category, ...rest } = queryParams;
    const { sortDirection, field } = sortedColumn;
    const categoryObject = categoryService.categoryQueryParamToCategoryObject(category);
    const downloadExcelPermitted = swSettings.current.resources.IsExcelAllowed;
    const excelLink = `${EXCEL_ENDPOINT}?${fetcherService.requestParams({
        ...rest,
        keys: categoryObject?.forApi,
        category: categoryObject?.forDisplayApi,
        includeSubdomains: true,
        sort: field,
        asc: sortDirection === "asc",
        ...(domainFilter && { filter: `Domain;contains;"${domainFilter}"` }),
    })}`;
    return (
        <SearchContainer>
            <SearchInput
                defaultValue={""}
                debounce={250}
                onChange={handleSearch}
                placeholder={i18nFilter()("category.conversion.table.search.placeholder")}
            />
            <DownloadButtonMenu
                Excel={true}
                downloadUrl={excelLink}
                excelLocked={!downloadExcelPermitted}
            />
        </SearchContainer>
    );
};
